/**
 * El probe `GET /getstaffsession` solo corre en la consola.
 * El producto no lo dispara: no delata el gate ni el path.
 */

export function isAdminPath(pathname) {
  return String(pathname || '').startsWith('/admin');
}

/**
 * @param {string} pathname
 * @param {boolean} isLoggedIn
 */
export function shouldProbeStaffSession(pathname, isLoggedIn) {
  return Boolean(isLoggedIn && isAdminPath(pathname));
}
